import { render, staticRenderFns } from "./SignUpEmailVerify.vue?vue&type=template&id=5720688e&"
import script from "./SignUpEmailVerify.vue?vue&type=script&lang=js&"
export * from "./SignUpEmailVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports